/**
 * Mobile App Integration Initialization
 * 
 * This module handles the initialization of mobile app integration features
 * when the web application loads. It sets up the mobile auth bridge and
 * ensures proper communication with the Flutter WebView.
 */

import { mobileAuthBridge } from './mobileAuthBridge';
import { mobileAuthService } from './mobileAuthService';
import { isMobileWebView, logEnvironmentInfo } from './mobileDetection';

/**
 * Initialize mobile app integration features
 * This should be called once when the app starts
 */
export const initializeMobileIntegration = () => {
  // Log environment information for debugging
  logEnvironmentInfo();

  if (isMobileWebView()) {
    // Initialize mobile auth bridge (legacy support)
    mobileAuthBridge.getEnvironmentInfo();
    
    // Initialize new mobile auth service
    mobileAuthService; // This triggers singleton initialization
    
    
    // Add a small delay to ensure WebView is fully ready, then signal readiness
    setTimeout(() => {
      // Dispatch a custom event to signal that the web app is ready for mobile interactions
      window.dispatchEvent(new CustomEvent('jampackdWebAppReady', {
        detail: {
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent,
          features: ['mobileAuth', 'webViewOptimization']
        }
      }));
      
    }, 500);
  }
};

/**
 * Check if mobile integration is properly initialized
 * @returns {boolean} True if mobile integration is working
 */
export const isMobileIntegrationReady = (): boolean => {
  if (!isMobileWebView()) {
    return false; // Not in mobile WebView
  }
  
  return mobileAuthBridge.shouldUseNativeAuth();
};